import { render, staticRenderFns } from "./ProblemModal.vue?vue&type=template&id=649488f8&scoped=true"
import script from "./ProblemModal.vue?vue&type=script&lang=js"
export * from "./ProblemModal.vue?vue&type=script&lang=js"
import style0 from "./ProblemModal.vue?vue&type=style&index=0&id=649488f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649488f8",
  null
  
)

export default component.exports